export default __webpack_public_path__ + "static/media/lumen-formula-stepper-1.a913104d.svg";